const rawBase = process.env.REACT_APP_BASENAME || "/dashboard";

export const getAppBasePath = () => {
  let base = rawBase || "/dashboard";
  if (!base.startsWith("/")) {
    base = `/${base}`;
  }
  base = base.replace(/\/+$/, "");
  return base || "/";
};

export const getAppPath = (path = "") => {
  const base = getAppBasePath();
  if (!path) return base;
  if (/^https?:\/\//i.test(path)) return path;

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  if (normalizedPath === base || normalizedPath.startsWith(`${base}/`)) {
    return normalizedPath;
  }
  return `${base}${normalizedPath}`;
};

export default {
  getAppBasePath,
  getAppPath,
};
